export default {
    modal: {
        logout: {
            title: 'Log Out',
            message: 'Would you like to log out?',
        },
        confirm: {
            title: 'Confirm',
            message: 'Are you sure you want to proceed?',
        },
    },

    dropdown: {
        selectOption: 'Select an option',
        noOptions: 'No options available',
    },

    table: {
        headers: {
            item: 'Item',
            content: 'Content',
            activity: 'Activity',
            mode: 'Mode',
            result: 'Result',
            time: 'Time',
            student: 'Student',
            answer: 'Answer',
            score: 'Score',
            status: 'Status',
        },
        noData: 'No data available',
        loading: 'Loading...',
    },

    form: {
        required: 'This field is required',
        invalid: 'Invalid format',
        saved: 'Saved successfully',
        errors: {
            network: 'A network error has occurred',
            validation: 'Please check your input and try again',
            server: 'A server error has occurred',
        },
    },

    loading: {
        default: 'Loading...',
        saving: 'Saving...',
        processing: 'Processing...',
        connecting: 'Connecting...',
    },

    toast: {
        success: 'Completed successfully',
        error: 'An error has occurred',
        warning: 'Attention required',
        info: 'Please check the information',
    },
};
